<template>
    <!-- 底部聊天输入框及表情输入框等 -->
    <div class="discuss-bottom-bar-box">
        <!-- 聊天输入框 -->
        <div class="discuss-bottom-input-bar dsp-flex">
            <!-- Todo::::先隐藏语音入口 -->
            <!-- <div class="discuss-bottom-item" @click="clickRecordButton"> -->
            <div class="discuss-bottom-item">
                <!-- <i class="iconfont" v-bind:class="{'icon-voice': !showRecordButton, 'icon-keyboard': showRecordButton}"></i> -->
            </div>
            <div v-if="!showRecordButton" class="discuss-bottom-input-item discuss-bottom-input-item-new">
                <!-- <form action="javascript:void(0)"> -->
                    <!-- <input class="discuss-bottom-input" type="text" /> -->
                    <!-- <input class="discuss-bottom-input" type="text" confirm-type="done" /> -->
                <!-- </form> -->
                <textarea id="discussText" class="discuss-bottom-textarea" name="" cols="30" rows="1" maxlength="2000" v-model="textValue" @focus="focusTextArea" @blur="blurTextArea" @input="inputTextArea"></textarea>
                <div id="fakeText" class="discuss-bottom-fake-textarea" @click="clickFakeTextArea">fake</div>
            </div>
            <div v-if="showRecordButton" class="discuss-bottom-input-item">
                <button class="discuss-button-record">按住 说话</button>
            </div>
            <div class="discuss-bottom-item" @click="clickExpButton">
                <i class="iconfont" v-bind:class="{'icon-expression': !showExpressions, 'icon-keyboard': showExpressions}"></i>
            </div>
            <!-- <div class="discuss-bottom-item" @click="clickExpandButton">
                <i class="iconfont icon-expand"></i>
            </div> -->
            <div class="discuss-bottom-item" @click="clickSendButton">
                <span class="discuss-button-send" v-bind:class="{'discuss-button-send-gray': !canSend}">发送</span>
            </div>
        </div>
        <!-- 表情列表框 -->
        <div v-if="showExpressions" class="discuss-bottom-expression-list">
            <van-swipe indicator-color="white" :loop="false" :stop-propagation="false" :initial-swipe='curIndex' @change="onChange">
                <van-swipe-item v-for="expList of expressionList" v-bind:key="'expression-' + expList.length + Math.random(0, 10)">
                    <span v-for="expression of expList" v-bind:key="'expression-' + expression + Math.random(0, 10)" @click.stop="clickExpression(expression)">{{expression.content}}</span>
                </van-swipe-item>
            </van-swipe>
            <div class="discuss-bottom-expression-bar dsp-flex">
                <div class="discuss-beb-item" @click="clickDelete"><span><i class="iconfont icon-jianpanguanbi"></i></span></div>
            </div>
        </div>
    </div>
</template>

<script>
import he from 'he'
import { WEIXIN, WEIXIN_CHAT } from '../../modules/weixin'
import { WS } from '../../modules/websocket';
import { UA } from '../../modules/utils';
import { DISCUSS_DOM } from '../../modules/dom'
export default {
    name: 'DiscussBottomBar',
    computed: {
        userInfo() {
            return this.$store.state.userData;
        },
        curUserUid() {
            return this.$store.state.discuss.curUserUid;
        },
        expressionList() {
            return this.$store.state.discuss.expressionList;
        }
    },
    data() {
        return {
            canSend: false,
            sendLock: false,
            textValue: '',
            showExpressions: false,
            showRecordButton: false,
            curIndex: 0
        }
    },
    created() {
        // 监听软件盘呼起or隐藏的事件
        var me = this,
            textNode = document.getElementById('discussText'),
            originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
        window.onresize = function() {
            if(textNode) {
                textNode.blur();
            }
            setTimeout(() => {
                DISCUSS_DOM.updateDiscussPageStyle();
            }, 0);
            if(UA.isIphone()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                    DISCUSS_DOM.resetDiscussFormScrollStyle();
                }, 0);
            }else if(UA.isAndroid()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                    var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                        DISCUSS_DOM.updateDiscussFormScrollStyle();
                    }else{
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                    }
                }, 0);
            }
        }
    },
    methods: {
        /**
         * 语音按钮事件
         */
        clickRecordButton() {
            this.showRecordButton = !this.showRecordButton;
            this.showExpressions = false;
            if(!this.showRecordButton) {
                this.textValue = '';
            }
        },
        /**
         * 表情按钮事件
         */
        clickExpButton() {
            this.showExpressions = !this.showExpressions;
            this.showRecordButton = false;
            var fakeNode = document.getElementById('fakeText');
            if(fakeNode) {
                fakeNode.style.display = 'block';
            }
            var me = this;
            if(this.showExpressions) {
                this.blurTextArea();
            }else {
                if(UA.isIphone()) {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                        DISCUSS_DOM.updateDiscussPageStyle();
                        DISCUSS_DOM.updateDiscussFormStyle();
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                        DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                    }, 10);
                }else {
                    this.clickFakeTextArea();
                }
            }
        },
        /**
         * 发送按钮事件
         */
        clickSendButton() {
            if(!this.canSend) { return; }
            if(this.sendLock) { return; }

            this.sendLock = true;
            var me = this;
            setTimeout(() => {
                me.sendLock = false;
            }, 500);
            // 空的字符串or全是换行符 不发送
            if(this.textValue.match(/^\s+$/) ||
                this.textValue.match(/^[ ]+$/) ||
                this.textValue.match(/^[ ]*$/) ||
                this.textValue.match(/^\s*$/)){
                this.textValue = '';
                this.canSend = false;
                this.$toast("不能发送空白消息");
                setTimeout(() => {
                    me.updateTextAreaHeight();
                }, 100);
                return;
            }
            console.log('sendMessage-------', this.curUserUid);
            this.$store.dispatch('discuss/sendMyWSMessage', {
                uid: this.curUserUid,
                msg_type: 1,
                content: this.textValue
            });
            WS.sendMessageWS({
                msg_type: 1,
                content: this.textValue
            });
            setTimeout(() => {
                me.resetForm();
                window.scrollTo(0, 0);
                DISCUSS_DOM.updateDiscussPageStyle();
                DISCUSS_DOM.updateDiscussFormStyle();
                DISCUSS_DOM.resetDiscussFormScrollStyle();
            }, 20);
        },
        /**
         * textarea上的空白遮罩层
         */
        clickFakeTextArea() {
            var me = this,
                fakeNode = document.getElementById('fakeText'),
                textNode = document.getElementById('discussText'),
                leng = this.textValue.length;
            fakeNode.style.display = 'none';
            textNode.setSelectionRange(leng, leng);
            textNode.focus();

            // 设置迷你命盘运盘的行数:::如果显示3行的话隐藏1行，输入状态下最多只显示2行；
            var showLines = this.$store.state.minifatefortune.showLines;
            if(showLines == 2) {
                this.$store.state.minifatefortune.showLines = 1;
            }
            
            var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
            if(UA.isPcWeChat()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussFormScrollStyle();
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                }, 0);
            }else if(UA.isIphone()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussFormScrollStyle();
                    setTimeout(() => {
                        DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                    }, 0);
                    // document.body.addEventListener('touchmove', me.stopTouch, { passive: false, capture: true })
                }, 100);
            }else if(UA.isAndroid()) {
                window.onresize = function() {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                        DISCUSS_DOM.updateDiscussFormScrollStyle();
                    }else{
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                    }
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                }
            }
        },
        focusTextArea() {
            this.showExpressions = false;
            if(UA.isPcWeChat()){
                this.bindKeyDownEvent();
            }
        },
        blurTextArea() {
            var me = this,
                fakeNode = document.getElementById('fakeText');
            fakeNode.style.display = 'block';
            
            var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
            // pc上的微信添加enter发送事件
            if(UA.isPcWeChat()) {
                this.unBindKeyDownEvent();
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                    DISCUSS_DOM.resetDiscussFormScrollStyle();
                }, 0);
            }else if(UA.isIphone()) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                    DISCUSS_DOM.resetDiscussFormScrollStyle();
                    // document.body.style = '';
                    // document.body.removeEventListener('touchmove', me.stopTouch, { capture: true })
                }, 100);
            }else if(UA.isAndroid()) {
                window.onresize = function() {
                    window.scrollTo(0, 0);
                    DISCUSS_DOM.updateDiscussPageStyle();
                    DISCUSS_DOM.updateDiscussFormStyle();
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                    var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if(parseInt(originalHeight) > parseInt(resizeHeight)) {
                        DISCUSS_DOM.updateDiscussFormScrollStyle();
                    }else{
                        DISCUSS_DOM.resetDiscussFormScrollStyle();
                    }
                }
            }

        },
        inputTextArea() {
            this.canSend = this.textValue.length > 0 ? true : false;
            this.updateTextAreaHeight();
        },
        stopTouch(e) {
            e.preventDefault()
        },
        updateTextAreaHeight() {
            // 自动撑开输入框的高度
            var fakeNode = document.getElementById('fakeText'),
                textNode = document.getElementById('discussText');
            
            if(this.textValue.length == 0) {
                fakeNode.style.height = '';
                textNode.style.height = '';
            }else {
                fakeNode.style.height = textNode.scrollHeight + 'px';
                textNode.style.height = textNode.scrollHeight + 'px';
            }
            // 更新外层的样式和位置
            if(UA.isIphone()) {
                setTimeout(() => {
                    DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
                }, 0);
            }else {
                window.scrollTo(0, 0);
                DISCUSS_DOM.updateDiscussPageStyle();
                DISCUSS_DOM.updateDiscussFormStyle();
                DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
            }
        },
        /**
         * 绑定回车按钮事件
         */
        bindKeyDownEvent() {
            var me = this;
            document.onkeydown = function(e) {
                // 兼容FF和IE和Opera
                var event = e || window.event;
                var key = event.which || event.keyCode || event.charCode;
                var bCtrlKeyCode = event.ctrlKey || event.metaKey;
                // ctrl + enter 换行
                if (key == 13 && bCtrlKeyCode) {
                    return;
                }

                if (key == 13) {
                    event.preventDefault();
                    me.clickSendButton();
                }
                
            };
        },
        /**
         * 撤销绑定回车按钮事件
         */
        unBindKeyDownEvent() {
            document.onkeydown = null;
        },
        /**
         * 点击表情事件
         */
        clickExpression(expressionData) {
            this.textValue = this.textValue + expressionData.code;
            this.canSend = this.textValue.length > 0 ? true : false;
            this.updateTextAreaHeight();
            return false;
        },
        /**
         * 表情输入框里的删除输入事件
         */
        clickDelete() {
            if(this.textValue == '') {
                return;
            }
            var me = this, curText = he.encode(this.textValue), newText = '',
                lastChar = curText.charAt(curText.length - 1),
                exppChar = curText.charAt(curText.length - 1 - 7),
                expppChar = curText.charAt(curText.length - 1 - 8),
                wordpChar = curText.charAt(curText.length - 1 - 6),
                wordppChar = curText.charAt(curText.length - 1 - 7);
            if(lastChar == ';') {
                if(exppChar == '#' && expppChar == '&') {
                    newText = curText.slice(0, curText.length - 9);
                }else if(wordpChar == '#' && wordppChar == '&'){
                    newText = curText.slice(0, curText.length - 8);
                }else{
                    newText = curText.slice(0, curText.length - 1);
                }
            }else {
                newText = curText.slice(0, curText.length - 1);
            }
            this.textValue = he.decode(newText);
            this.canSend = this.textValue.length > 0 ? true : false;

            setTimeout(() => {
                me.updateTextAreaHeight();
            }, 0);
        },
        resetForm() {
            this.textValue = '';
            this.showExpressions = false;
            this.updateTextAreaHeight();
            var fakeNode = document.getElementById('fakeText'),
                textNode = document.getElementById('discussText');
            fakeNode.style.height = '';
            textNode.style.height = '';
        },
        clickExpandButton() {
            var me = this;
            WEIXIN_CHAT.chooseImage(function(localId, localData){
                me.$store.dispatch('discuss/chatSendImage', {
                    localId: localId, localData: localData
                })
            });
        },
        onChange(index) {
            this.curIndex = index;
        }
    }
}
</script>